module.exports = __webpack_public_path__ + "static/img/right-top-row-7.b6b1ec29.webp";